import { createAsyncThunk } from '@reduxjs/toolkit';

import { apiService } from '../../services/api-service';
import { QueueStatus } from '../../types/api';
import {
  isClosedWithinOpeningHours,
  isWithinOpeningHours
} from '../../utils/helpers';
import { RootState } from '../store';

export const fetchChatAvailability = createAsyncThunk<
  QueueStatus,
  void,
  { state: RootState }
>('chatAvailability/request', async (_, { getState }) => {
  const state = getState();

  let masterIsAvailable = true;
  if (state.config.masterQueue?.length) {
    const availability = await apiService.getChatQueueAvailability(
      state.config.masterQueue,
      false
    );

    masterIsAvailable = availability.available;
  }

  if (masterIsAvailable) {
    const { selectedEntrance } = state.config;
    if (selectedEntrance) {
      return apiService.getChatAvailabilityByEntrance(selectedEntrance);
    } else {
      const shortNames = state.config.useServiceQueues
        ? state.config.serviceQueuesShortNames
        : state.config.shortNames;
      const shortNameAndEntrance = state.config.useServiceQueues
        ? state.config.serviceQueuesShortNamesAndEntrances
        : state.config.shortNamesAndEntrances;
      return apiService.getChatQueueEntranceAvailability(shortNameAndEntrance);
    }
  }

  return { available: true };
});

export const fetchChatOpeningHours = createAsyncThunk<
  { isWithinOpeningHours: boolean; isClosedWithinOpeningHours: boolean },
  void,
  { state: RootState }
>('chatOpeningHours/request', async (_, { getState }) => {
  const { config } = getState();

  const entrance =
    config.directEntrance ||
    (config.directEntrances ? config.directEntrances[0].entrance : null);

  if (!entrance) {
    return { isWithinOpeningHours: false, isClosedWithinOpeningHours: false };
  }

  try {
    const openingHours = await apiService.getOpeningHours(entrance);
    const intervals = config.defaultOpeningHours;

    if (intervals) {
      return {
        isWithinOpeningHours: isWithinOpeningHours(intervals, openingHours),
        isClosedWithinOpeningHours: isClosedWithinOpeningHours(
          intervals,
          openingHours
        )
      };
    }

    return { isWithinOpeningHours: false, isClosedWithinOpeningHours: false };
  } catch (e) {
    console.error(e);
    return { isWithinOpeningHours: false, isClosedWithinOpeningHours: false };
  }
});
